import RTAppBar from "./styles/RTAppBar.scss";
import RTAvatar from "./styles/RTAvatar.scss";
import RTButton from "./styles/RTButton.scss";
import RTCheckbox from "./styles/RTCheckbox.scss";
import RTDatePicker from "./styles/RTDatePicker.scss";
import RTDialog from "./styles/RTDialog.scss";
import RTDrawer from "./styles/RTDrawer.scss";
import RTInput from "./styles/RTInput.scss";
import RTList from "./styles/RTList.scss";
import RTMenu from "./styles/RTMenu.scss";
import RTProgressBar from "./styles/RTProgressBar.scss";
import RTRadio from "./styles/RTRadio.scss";
import RTSwitch from "./styles/RTSwitch.scss";
import RTTabs from "./styles/RTTabs.scss";
import RTTooltip from "./styles/RTTooltip.scss";

export default {
    RTAppBar,
    RTAvatar,
    RTButton,
    RTCheckbox,
    RTDatePicker,
    RTDialog,
    RTDrawer,
    RTInput,
    RTList,
    RTMenu,
    RTProgressBar,
    RTRadio,
    RTSwitch,
    RTTabs,
    RTTooltip
};
